export default "__VITE_ASSET__CfueFKEH__"